module.exports = __webpack_public_path__ + "img/home_img_carrypassenger@2x.7a7a2fda.png";